export const QUESTION_CATEGORY_META = {
    pattern_matrix: {
        label: "Μοτίβα & Matrix",
        description: "Αναγνώριση οπτικών κανόνων, μεταβολών, σχέσεων και μοτίβων."
    },
    spatial_reasoning: {
        label: "Χωρική Αντίληψη",
        description: "Νοητική περιστροφή, αντιστοίχιση και κατανόηση οπτικών σχέσεων στον χώρο."
    },
    number_symbol: {
        label: "Ακολουθίες & Σύμβολα",
        description: "Εντοπισμός κανόνων σε αριθμητικές ή συμβολικές ακολουθίες."
    },
    logical_deduction: {
        label: "Λογική Συμπερασμάτων",
        description: "Χρήση κανόνων, αποκλεισμός επιλογών και αν-τότε συλλογισμός."
    },
    processing_speed: {
        label: "Ταχύτητα & Προσοχή",
        description: "Γρήγορος εντοπισμός οπτικών στοιχείων και ακρίβεια απόκρισης υπό ήπια χρονική πίεση."
    },
    verbal_reasoning: {
        label: "Λεκτική Λογική",
        description: "Κατανόηση σχέσεων, αναλογιών και εννοιών μέσα από σύντομες λεκτικές ερωτήσεις."
    }
};
export const QUESTION_SUBTYPES = {
    pattern_matrix: [
        "matrix_3x3_missing",
        "missing_part_tile",
        "tile_rotation_matrix",
        "position_grid_movement",
        "dot_pattern_matrix",
        "dot_xor_rotation_sequence",
        "dot_alternating_groups_sequence",
        "mini_grid_symbol_completion",
        "hex_xor_rotation_matrix",
        "circle_segment_union_matrix",
        "pie_slice_union_matrix",
        "symbol_grid_step_sequence",
        "blue_circle_dot_comparison_matrix",
        "symbol_left_shift_matrix_5x5",
        "rounded_dome_color_matrix",
        "quadrant_color_shape_matrix_4x3",
        "mini_grid_symbol_cycle_matrix",
        "figural_reasoning",
        "figure_completion",
        "visual_rule_transform"
    ],
    spatial_reasoning: ["rotation_2d", "mirror_match", "part_whole_match", "cube_folding_lite", "orientation_grid", "mini_grid_symbol_completion", "top_view_identification", "color_grid_transform_matrix"],
    number_symbol: ["number_sequence", "alternating_sequence", "symbol_sequence", "visual_equation", "relation_completion", "alphanumeric_dual_sequence", "symbol_arithmetic_chain"],
    logical_deduction: ["rule_elimination", "odd_one_out", "if_then_rule", "category_relation", "rule_grid", "xor_matrix", "circle_half_fill_matrix"],
    processing_speed: ["hidden_target", "visual_search", "same_different", "quick_count", "visual_matching", "attention_grid", "dot_movement_sequence", "color_block_odd_one_out_sequence", "neon_tile_odd_one_out_sequence"],
    verbal_reasoning: ["verbal_analogy", "word_relation", "category_analogy", "odd_word_out"]
};
export function isAllowedSubtype(category, subtype) {
    return QUESTION_SUBTYPES[category].includes(subtype);
}
export function getCategoryLabel(category) {
    return QUESTION_CATEGORY_META[category].label;
}
export function getCategoryDescription(category) {
    return QUESTION_CATEGORY_META[category].description;
}
